import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CodesaResponseData } from '@core/response/codesa-reponse-data';
import { CodesaResponseList } from '@core/response/codesa-reponse-list';
import { ServiceBase } from '@core/services/service-base';


const service = 'coreService';

@Injectable({
    providedIn: 'root'
})
export class ReportsService extends ServiceBase {

    constructor(
        private http: HttpClient
    ) {
        super(service);
    }

    printReport(idRegistrationPreSorteoGNA: number): Promise<any> {
        return this.http.get<any>(`${this.url}/admin/reports/pre-sorteo`, {
            params: {
                "idRegistrationPreSorteoGNA": idRegistrationPreSorteoGNA
            },
            observe: 'response',
            responseType: 'blob' as 'json'
        }).toPromise();
    }
}
